import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { AccaBoostToken } from '../../../reward-tokens/reward-tokens.model';

@Directive({
    selector: '[bsAccaRerenderer]',
    standalone: false,
})
export class AccaBoostRerendererDirective {
    private id?: string;

    @Input()
    set bsAccaRerenderer(token: AccaBoostToken) {
        if (this.id !== token.userTokenId) {
            this.viewContainer.clear();
            this.viewContainer.createEmbeddedView(this.templateRef);
        }

        this.id = token.userTokenId;
    }

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
    ) {}
}
